import { RtLoaderFn } from "../RtLoader";
import { AbstractFilters, AbstractRow } from "../RtTypes";
import {
  applyRequest,
  ApplyRequestOptions,
} from "./clientDataCtrl/applyRequest";

/**
 * All data is returned in one request.
 * Filtering is performed on the client. No data modification is expected.
 * @param task A query that is called once the first time it is accessed.
 * @param options filtration rules
 */
export const singleRtLoader = <
  TRow extends AbstractRow,
  TFilters extends AbstractFilters,
>(
  task: () => Promise<TRow[]>,
  options?: ApplyRequestOptions<TRow, TFilters>,
): RtLoaderFn<TRow, TFilters> => {
  let srcRows: TRow[] | undefined;
  return async (request) => {
    if (!srcRows) {
      srcRows = await task();
    }
    return applyRequest(srcRows!, request, options);
  };
};
